/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kn_Health_UnknownInputs */

const cs_kn_health_unknown = /** @type {(inputs: Kn_Health_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stav neznámý`)
};

const en_kn_health_unknown = /** @type {(inputs: Kn_Health_UnknownInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Status unknown`)
};

/**
* | output |
* | --- |
* | "Status unknown" |
*
* @param {Kn_Health_UnknownInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const kn_health_unknown = /** @type {((inputs?: Kn_Health_UnknownInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kn_Health_UnknownInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kn_health_unknown(inputs)
	return cs_kn_health_unknown(inputs)
});